import styled, { css } from "styled-components";
import { DialogOverlay, DialogContent } from "@reach/dialog";
import { position, rgba } from "polished";
import { fadeInEffect } from "../../animations/effects.es.js";
import { easeOutCirc } from "../../animations/timing-functions.es.js";
const overlayAnimation = css`
  animation: ${fadeInEffect} 0.3s;
  animation-fill-mode: forwards;
  opacity: 0;
`;
const contentAnimation = css`
  animation: ${fadeInEffect} 0.5s 0.1s ${easeOutCirc};
  animation-fill-mode: forwards;
  opacity: 0;
`;
const OverlayFrame = styled(DialogOverlay)(
  {
    display: "flex",
    padding: 16,
    ...position("fixed", 0),
    transform: "translateZ(0)"
  },
  css`
    &::before {
      ${({ $animation }) => $animation ? overlayAnimation : null};
      background-color: ${rgba("black", 0.45)};
      content: ' ';
      ${position("fixed", 0)}
    }
  `
);
const OverlayContent = styled(DialogContent).attrs({
  tabIndex: -1
})(
  ({ theme }) => ({
    outlineStyle: "none",
    backgroundColor: "white",
    borderRadius: 4,
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
    color: theme.color.gray8,
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    margin: "auto",
    maxHeight: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    zIndex: 1
  }),
  ({ $animation }) => $animation ? contentAnimation : null,
  ({ $height }) => ({ height: $height }),
  ({ $minHeight }) => ({ minHeight: $minHeight }),
  ({ $minWidth }) => ({ minWidth: $minWidth }),
  ({ $width = "min-content" }) => ({ width: $width }),
  ({ xFrom }) => ({ left: xFrom }),
  ({ yFrom }) => ({ top: yFrom })
);
export {
  OverlayContent,
  OverlayFrame
};
